module.exports = __webpack_public_path__ + "img/v4_h5.8ac9d061.png";